module.exports = __webpack_public_path__ + "img/sdgs_work_efficiency.c17c2a2b.jpeg";